import { render, staticRenderFns } from "./topHeader.vue?vue&type=template&id=454e9e8e&scoped=true&"
import script from "./topHeader.vue?vue&type=script&lang=js&"
export * from "./topHeader.vue?vue&type=script&lang=js&"
import style0 from "./topHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e9e8e",
  null
  
)

export default component.exports